const translations = {
    acresPerTank: 'Acres/Tank',
    appTank: 'App Tank (gal)',
    applicationContext: 'Application Context',
    applicatorLicense: 'Applicator License',
    applicatorName: 'Applicator',
    autoFill: 'Auto-fill from weather',
    batches: 'Batches',
    calculations: 'Calculations',
    carrierInsufficient: 'Product volume exceeds carrier — increase GPA or reduce load',
    carrierRate: 'Carrier Rate (gal/ac)',
    carrierType: 'Carrier',
    complianceReportButton: 'Generate State Compliance Report',
    configuration: 'Configuration',
    county: 'County',
    crop: 'Crop',
    customer: 'Customer',
    customerAddress: 'Customer Address',
    date: 'Date',
    dicambaOverlay: 'Dicamba overlay thresholds apply — wind 3-10 mph, temp <= 95 degrees F.',
    editMixDefinition: 'Edit Mix Definition',
    emptyRecipe: 'Empty recipe',
    errorLoadingRecipe: 'Unable to load mix recipe. Displaying last known data.',
    faaNumber: 'FAA N-Number',
    field: 'Field',
    fillsPerBatch: 'Fills/Batch',
    gust: 'Gust (mph)',
    humidity: 'Humidity (%)',
    licenseDeadline: 'Record-keeping deadline: 30 days ({{state}})',
    licenseValid: 'Applicator license valid',
    loadingRecipe: 'Loading mix recipe...',
    mixTank: 'Mix Tank (gal)',
    orgDefaults: 'Org Defaults',
    partialLastTank: 'Partial Last Tank',
    partialTankWarning:
        'Last application tank will be partial — plan drain or top-off for {{gallons}} gal.',
    perTankHeader: 'Per Tank ({{unit}})',
    productAmounts: 'Product Amounts',
    productHeader: 'Product',
    productLicenseBlock: '{{product}} unlicensed in {{state}}',
    productRateLabel: 'Per-application rate',
    productVolume: 'Product Volume',
    ready: 'Ready',
    recipe: 'Mix Recipe',
    stateCompliance: 'State Compliance',
    stateComplianceFor: 'State Compliance — {{state}}',
    status: 'Status',
    targetPest: 'Target Pest',
    temperature: 'Temperature (degrees F)',
    title: 'Mix & Apply',
    totalAcres: 'Total Acres',
    totalAppFills: 'Total App Fills',
    totalHeader: 'Total ({{unit}})',
    totalSprayVolume: 'Total Spray Volume',
    unitGal: 'gal',
    unitOz: 'oz',
    usStatePrefix: 'State',
    waterVolume: 'Water Volume',
    weather: 'Weather Conditions',
    weatherInfo: 'Auto-fill pulls station readings.',
    weatherIssue: 'Weather issue',
    weatherValidation: 'Weather Validation',
    weatherValidationOrgDefaults: 'Weather Validation — Org Defaults',
    windDirection: 'Wind Direction',
    windSpeed: 'Wind (mph)'
};

export default translations;
